<app-modal title="Registro de Vacina" [isOpen]="isOpen()" (closed)="onCloseModal()">
  @if(isDelete()){
  <p class="mt-2 mb-8">Você tem certeza que deseja deletar este registro?</p>
  <div class="flex justify-end mt-4">
    <p-button label="Cancelar" type="button" class="mr-2" [disabled]="isLoading()" (click)="onCloseModal()" />
    <p-button label="Deletar" type="button" icon="pi pi-trash" styleClass="p-button-danger"
      (click)="deleteVaccineHistory()" [disabled]="isLoading()" />
  </div>

  } @else { @if(vaccineHistory()) {
  <div class="mb-4 flex justify-end">
    <p [ngClass]="{
        'text-red-500': isEnabled(),
        'text-gray-400': !isEnabled()
      }" class="font-semibold mr-2">
      {{ isEnabled() ? "Cancelar" : "Editar" }}
    </p>
    <p-toggleswitch [(ngModel)]="isEnabled" />
  </div>
  }
  <app-vaccine-history-form [(isLoading)]="isLoading" (onSubmit)="createOrUpdateVaccineHistory($event)"
    [initialData]="vaccineHistory()" [(enabled)]="isEnabled" />
  }
</app-modal>